import { env } from '@packages/runtime-config';

const GA4_MEASUREMENT_ID = 'G-6QJNDX5F5V';
const YANDEX_METRIKA_ID = 109188791;
const FACEBOOK_PIXEL_ID = '2703696880009704';
const GTM_ID = 'GTM-M2WJMK6G';

declare global {
  interface Window {
    dataLayer?: IArguments[];
    gtag?: (...args: unknown[]) => void;
    ym?: (...args: unknown[]) => void;
  }
}

function appendInlineScript(code: string) {
  const script = document.createElement('script');
  script.textContent = code;
  document.head.appendChild(script);
}

function loadFacebookPixel() {
  appendInlineScript(`!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${FACEBOOK_PIXEL_ID}');
fbq('track', 'PageView');`);
}

function loadGtm() {
  appendInlineScript(`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}');`);
}

function loadYandexMetrika() {
  appendInlineScript(`(function(m,e,t,r,i,k,a){
    m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
    m[i].l=1*new Date();
    for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
    k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
})(window, document,'script','https://mc.yandex.ru/metrika/tag.js?id=${YANDEX_METRIKA_ID}', 'ym');

    ym(${YANDEX_METRIKA_ID}, 'init', {ssr:true, webvisor:true, clickmap:true, ecommerce:"dataLayer", referrer: document.referrer, url: location.href, accurateTrackBounce:true, trackLinks:true});`);
}

function loadGa4() {
  window.dataLayer = window.dataLayer ?? [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params -- keep GA queue format
    window.dataLayer!.push(arguments);
  };

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
  script.onload = () => {
    window.gtag?.('js', new Date());
    window.gtag?.('config', GA4_MEASUREMENT_ID, { send_page_view: true });
    window.gtag?.('event', 'page_view', {
      send_to: GA4_MEASUREMENT_ID,
      page_location: window.location.href,
      page_title: document.title,
    });
  };
  document.head.appendChild(script);
}

/**
 * Counters enabled on the stand by APP_ENABLE_*=1. Called in entry.client before the render:
 * config.js is loaded by then, unlike the shell prerendered at build time.
 */
export function loadAnalytics() {
  if (env.ENABLE_FACEBOOK_PIXEL === '1') {
    loadFacebookPixel();
  }
  if (env.ENABLE_GTM === '1') {
    loadGtm();
  }
  if (env.ENABLE_YANDEX_METRIKA === '1') {
    loadYandexMetrika();
  }
  if (env.ENABLE_GA4 === '1') {
    loadGa4();
  }
}
